import ProducePricesPage from "./ProducePrices";
import {
  loadFeaturedVegetableIds,
  saveFeaturedVegetableIds,
  vegetableEmoji,
  vegetableImage,
} from "../vegetable_catalog";

function VegetablesPage() {
  return (
    <ProducePricesPage
      title="Vegetable Prices"
      itemName="vegetable"
      itemNamePlural="vegetables"
      apiPath="/api/vegetables"
      itemsKey="vegetables"
      loadFeatured={loadFeaturedVegetableIds}
      saveFeatured={saveFeaturedVegetableIds}
      emojiFor={vegetableEmoji}
      imageFor={vegetableImage}
    />
  );
}

export default VegetablesPage;
